import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import styles from './assets/styles.scss';
import copyToClipboard from '../../helpers/copyToClipboard';

import IconCopy from './assets/copy.svg?inline';
import IconLink from './assets/link.svg?inline';

const cx = classNames.bind(styles);

export default function Detail({
  label, inline, content, className, contentClassName, copiable, href, copyText,
}) {
  const labelComponent = <span className={cx('small', 'label')}>{label}</span>;

  function getContent() {
    if (React.isValidElement(content)) {
      return content;
    }
    return <span className={`${cx('left')} ${contentClassName}`}>{content}</span>;
  }

  return (
    <div className={`${cx('detail', { inline })} ${className}`}>
      {!inline && labelComponent}
      <div className={cx('content')}>
        {inline && labelComponent}
        {getContent()}
        <div className={cx('right')}>
          {copiable && (
            <button type="button" className={cx('button')} onClick={() => copyToClipboard(copyText || content)}>
              <IconCopy />
            </button>
          )}
          {!!href && (
            <a href={href} className={cx('button')} target="_blank" rel="noreferrer">
              <IconLink />
            </a>
          )}
        </div>
      </div>
    </div>
  );
}

Detail.propTypes = {
  label: PropTypes.string.isRequired,
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.element]),
  inline: PropTypes.bool,
  className: PropTypes.string,
  contentClassName: PropTypes.string,
  copiable: PropTypes.bool,
  href: PropTypes.string,
  copyText: PropTypes.string,
};
Detail.defaultProps = {
  inline: false,
  className: '',
  content: '',
  contentClassName: '',
  copiable: false,
  href: '',
  copyText: '',
};
